const AWS = require('aws-sdk');

AWS.config.update({
  region: process.env.VUE_APP_AWS_REGION,
  credentials: new AWS.CognitoIdentityCredentials({ IdentityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID }),
});

const s3 = new AWS.S3();
const Bucket = process.env.VUE_APP_S3_BUCKET;

export default {
  state: {
  },
  upload(filePath, file) {
    return new Promise((resolve, reject) => {
      s3.upload({ Bucket, Body: file, Key: filePath }).promise().then((response) => {
        console.log(response);
        resolve(response);
      }).catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },
  delete(filePath) {
    return new Promise((resolve, reject) => {
      s3.deleteObject({ Bucket, Key: filePath }).promise().then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  list(bucketName, filePath) {
    return new Promise((resolve, reject) => {
      s3.listObjects({ Bucket: bucketName, Prefix: filePath }).promise().then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
};
